export default __webpack_public_path__ + "static/media/shield.8668a472.png";